import type { CommandBody } from '../CrossOriginMessage';

/**
 * Used to open a print view.
 */
export class PrintCommandBody implements CommandBody {}
